module.exports = __webpack_public_path__ + "static/media/gif.743f1fa3.svg";